import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import seo from '../data/seo.json';

export default function ServiceAreaSection() {
  return (
    <section className="py-20 px-6 bg-white" data-testid="service-area-section">
      <div className="max-w-6xl mx-auto">
        <p className="text-[#8B6914] text-sm font-semibold tracking-widest uppercase mb-3">Service Area</p>
        <h2 className="font-serif text-3xl md:text-4xl text-[#1A1A1A] mb-4">Serving Spokane & Nearby</h2>
        <p className="text-[#5C5446] text-base md:text-lg max-w-3xl mb-10">
          Espresso Beso brings mobile espresso and coffee catering to weddings, corporate events, graduations and family
          gatherings across Spokane, Spokane Valley, Liberty Lake, Cheney, Airway Heights, Mead and the rest of the Inland
          Northwest, including Post Falls and Coeur d'Alene, Idaho.
        </p>
        <div className="flex flex-wrap gap-3">
          {seo.cities.map((c) => (
            <Link
              key={c.slug}
              to={`/coffee-catering/${c.slug}`}
              className="group inline-flex items-center gap-2 bg-[#F5F0E1] hover:bg-[#1A1A1A] text-[#1A1A1A] hover:text-white rounded-full px-5 py-2.5 text-sm font-medium transition-colors"
              data-testid={`city-link-${c.slug}`}
            >
              <MapPin className="w-4 h-4 text-[#D4AF37]" />
              {c.name}, {c.state}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
